import { useQuery } from 'react-query';

import { getManagersInfo } from 'api/iamOrchestrationApi';

export const useGetManagersInfo = () =>
  useQuery('getManagersInfo', getManagersInfo);
